import { Api } from '@axiom/ui';
import type { AfcSubmissionsItem } from '@axiom/validation';
import type { SelfServiceHelpRequired } from '@axiom/const';

import { EnvUtil } from '../utils/env-util';

class SelfServiceApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiAltUrl,
    });
  }

  async createHelpRequest(body: {
    submissionId: AfcSubmissionsItem['id'];
    helpRequired: SelfServiceHelpRequired;
  }) {
    return super.write<{ data: null }>({
      endpoint: `/self-service/help`,
      method: 'POST',
      body,
    });
  }
}

export const SelfServiceApi = new SelfServiceApiClass();
